import '../shared/index.js';
import '../authentication/stylesheets/index.js.erb';
import '../authentication/javascripts/index.js.erb';

document.addEventListener('turbolinks:load', ()=>{
  window.Rewardful && window.Rewardful.Forms.attach();
});
